import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useProjectsListPageContent } from '../../hooks/useProjectListPageContent';
import { useProjectsDataGridFetch } from '../../hooks/useProjectsDataGridFetch';

export const ProjectsListPageContent = () => {
  const { columnDefinition, onStudyCellClick, sortModel, messages } = useProjectsListPageContent();

  return (
    <DataGridLayout id="projects-datagrid-layout">
      <DataGrid
        id="project-list"
        mode="client"
        getRowId={(row) => row.projectId}
        columns={columnDefinition}
        useFetchDataGridData={useProjectsDataGridFetch}
        pageSizeOptions={[1, 5, 10, 25, 50, 100]}
        onCellClick={onStudyCellClick}
        messages={messages}
        initialState={{
          sorting: {
            sortModel,
          },
        }}
      />
    </DataGridLayout>
  );
};
